import React from 'react';
import './PropertiesStatus.scss';

export interface PropertiesStatusProps {
  isLoading: boolean;
  error: string | null;
  propertiesCount: number;
}

export const PropertiesStatus = ({
  isLoading,
  error,
  propertiesCount,
}: PropertiesStatusProps) => {
  if (isLoading) {
    return (
      <div className="properties-status properties-status--loading">
        Loading properties...
      </div>
    );
  }

  if (error) {
    return (
      <div className="properties-status properties-status--error">{error}</div>
    );
  }

  if (propertiesCount === 0) {
    return (
      <div className="properties-status properties-status--empty">
        No properties available
      </div>
    );
  }

  return null;
};
